import React from 'react';
import Img from 'gatsby-image';

export default props => (
  <section className="team-1" id="aboutUs">
    <div className="container">
      <div className="row">
        <div className="col-md-8 col-md-offset-2 text-center">
          <h1>Nasz zespół</h1>
        </div>
      </div>

      <div className="row">
        <div className="col-xs-12 col-md-6">
          <div className="team-1-member">
            <Img
              resolutions={props.marek}
              imgStyle={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
              }}
              style={{ width: '220px', height: '220px', borderRadius: '50%' }}
            />
            <h5>Marek Krupa</h5>
            <span>Założyciel &amp; Administrator Bezpieczeństwa Informacji</span>
          </div>
        </div>

        <div className="col-xs-12 col-md-6">
          <div className="team-1-member">
            <Img
              resolutions={props.kasia}
              imgStyle={{
                width: '100%',  
                height: '100%',
                objectFit: 'contain',
              }}
              style={{ width: '220px', height: '220px', borderRadius: '50%' }}
            />
            <h5>Katarzyna Klimanek-Rychlik</h5>
            <span>Prawnik</span>
          </div>
        </div>
      </div>
    </div>
  </section>
);



// WEBPACK FOOTER //
// ./src/components/Team.js